export default __webpack_public_path__ + "static/media/Trailtracker.940ac97b.png";